import {MOUSE_BUTTONS} from 'shared/ui-widgets/grid/constants';
import {exists} from 'shared/utils/custom-utils';

// native click and dblclick may not be working
// if you already listen for mousedown or mouseup events and possibly call preventDefault
export function detectDoubleClick(node: HTMLElement) {
    const DOUBLE_CLICK_DELAY = 300;

    let clickCount = 0;
    let clickTimeout: number | null = null;
    let eventTarget: EventTarget | null = null;

    function handleMouseDown(event: MouseEvent) {
        if (event.button !== MOUSE_BUTTONS.LEFT) {
            reset(); // reset if other than left mouse button is clicked
            return;
        }

        clickCount += 1;

        if (clickCount === 1) {
            // reset if no 2nd click happens during delay period
            clickTimeout = window.setTimeout(reset, DOUBLE_CLICK_DELAY);
            eventTarget = event.target; // save last event target
            return;
        }

        if (clickCount === 2) {
            if (event.target === eventTarget) {
                // if 2nd click on the same element, stop original event and trigger dblclick on event target
                event.preventDefault();
                event.stopImmediatePropagation();
                triggerDblclick(event);
            }
            reset();
        }
    }

    function triggerDblclick(originalEvent: MouseEvent) {
        const dblclickEvent = new MouseEvent('dblclick', {
            view: window,
            bubbles: true,
            cancelable: true,
        });
        originalEvent.target.dispatchEvent(dblclickEvent);
    }

    function reset() {
        clickCount = 0;
        eventTarget = null;
        if (exists(clickTimeout)) {
            window.clearTimeout(clickTimeout);
            clickTimeout = null;
        }
    }

    node.addEventListener('mousedown', handleMouseDown);

    return {
        destroy() {
            reset();
            node.removeEventListener('mousedown', handleMouseDown);
        }
    };
}